<template>
    <div class="bg-white px-3 index"  >
        <div class="add_tits" ref="title">
            <el-form class="form-inlines" :inline="true">
                <el-form-item label="日期:">
                    <el-date-picker v-model="formData.time" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" size='small' value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="专家:">
                    <el-select v-model="formData.docname" placeholder="请选择" size="small" filterable clearable>
                        <el-option v-for="item in  formData.doc_options" :key="item.id" :label="item.nickname"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类型:">
                    <el-select v-model="formData.lx_value" placeholder="请选择" size="small" filterable clearable>
                        <el-option v-for="item in  formData.lx_options" :key="item.id" :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-printer" size="small" plain @click="openExportExcel">
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
                <el-table-column prop="create_time" label="日期" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="grantee_name" label="专家" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="price" label="新增代入帐金额" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="pay_price" label="用户实际支付金额" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="source_text" label="类型" show-overflow-tooltip> </el-table-column>

            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>

        </div>
        <!-- 导出 -->
        <el-dialog title="导出数据" :visible.sync="exportModal" center width="30%">
            <el-form :model="exportForm" ref="ruleForm">
                <el-form-item label="时间范围" required>
                    <el-date-picker size="small" v-model="exportForm.time" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="exportModal = false">取 消</el-button>
                <el-button type="primary" :loading='exporloading' @click="exportExcel">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                formData: {
                    time: '',
                    docname: '',
                    lx_value: '',
                    doc_options: [],
                    lx_options: [{
                            id: 1,
                            name: '付费咨询'
                        },
                        {
                            id: 2,
                            name: '头条打赏'
                        },
                        {
                            id: 3,
                            name: '发布文章奖金'
                        },
                        {
                            id: 4,
                            name: '用户报道奖金'
                        },
                        {
                            id: 5,
                            name: '活动奖金'
                        },
                    ],
                },
                loading: false,
                tableData: [],
                currentPage: 1,
                pagesize: 15,
                count: 0,
                heights: null,
                dialogVisible: false,
                date: xaoi.date,
                exportModal: false,
                exportForm: {
                    time: []
                },
                exporloading:false,
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getall()
            that.getHeight()
            that.getDate6()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 200 + 'px'
                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 200 + 'px'
                }
            },
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/pc/CapitalDetails/detailList", {
                        page: that.currentPage,
                        page_count: that.pagesize,
                        start_time: this.formData.time ? this.formData.time[0] : '',
                        end_time: this.formData.time ? this.formData.time[1] : '',
                        user_id: this.formData.docname,
                        source: this.formData.lx_value,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.count
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            getall() {
                this.getdoc()
            },
            getdoc() {
                axios
                    .post("/admin/doctorAssistantList", {
                        type:9
                    }, {
                        token: true
                    })
                    .then(response => {
                        this.formData.doc_options = response.data.data
                    })
                    .catch(error => {})
            },
            //本月
            getDate6() {
                let that = this
                var date = new Date();
                date.setDate(1);
                var month = parseInt(date.getMonth() + 1);
                var day = date.getDate();
                month = month < 10 ? "0" + month : month;
                day = day < 10 ? "0" + day : day;
                var start = date.getFullYear() + "-" + month + "-" + day;
                var date = new Date();
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                month = month < 10 ? "0" + month : month;
                var day = new Date(year, month, 0);
                var end = year + "-" + month + "-" + day.getDate();
                this.formData.time = [start, end]
                that.begin()
            },
            openExportExcel() {
                this.exportModal = true
            },
            exportExcel() {
                if (this.exportForm.time.length == 0) return this.$message.error('请选择时间范围')
                let val = this.exportForm.time
                let params = ''
                if (val && Array.isArray(val)) {
                    params += `starttime=${val[0]}`
                    params += `&endtime=${val[1]}`
                }
                let url = `/admin/pc/Excel/docZjmx2Excel?`

                this.exporloading = true
                this.axios.post(url + params, {}, {
                    token: true,
                    responseType: 'blob'
                }).then(res => {
                    if (res.status == 200) {
                        this.exportModal = false
                        let url = window.URL.createObjectURL(new Blob([res.data]))
                        let link = document.createElement('a')
                        link.style.display = 'none'
                        link.href = url
                        let filename = new Date().getTime() + '.xlsx';
                        link.setAttribute('download', filename)
                        document.body.appendChild(link)
                        link.click()
                    } else if (res.data.code != 200) {
                        this.$message('暂无数据')
                    }
                    this.exporloading = false

                }).catch(err => {
                    this.exporloading = false

                })
            }



        },

    };
</script>


<style>

</style>